"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deLocaleData = require("i18next-icu/locale-data/de");
exports.default = deLocaleData;
//# sourceMappingURL=de.js.map